import cn from 'classnames';
import { size } from 'lodash-es';
import { checkIsNull } from '../../Utils/utils';

const CSS_UID = 'field-input-ssn-24qsdfssfg4-00f8-4e7b-8825-dd064f4176a9';
export const INPUT_1_CLASS = 'input_1';
export const INPUT_2_CLASS = 'input_2';

/**
 * slice value
 * @param {*} value
 * @param {*} start
 * @param {*} end
 */
export const sliceValue = (value, start, end) => {
  try {
    if (!checkIsNull(value)) {
      return value.slice(start, end);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`sliceValue ${e.stack}`);
  }
  return value;
};

/**
 * parse value decimal digits
 * @param {*} value
 * @param {*} digits
 */
export const checkFormatValueSlice = (value, slice) => {
  try {
    if (!checkIsNull(value)) {
      const length = size(value);
      if (length > slice) {
        return sliceValue(value, 0, slice);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`checkFormatValueSlice ${e}`);
  }
  return value;
};

/**
 *  add class name
 * @param {*} param0
 */
export const addClassName = ({ inputClass, existError, showError }) =>
  cn(CSS_UID, inputClass, {
    exist_error_style: existError,
    show_error_style: showError,
    valid_style: !existError && !showError,
  });
